import React from 'react'
import { NavLink } from 'react-router-dom';
import './Signup.css'
function Signup() {

  return (
    <div>
      <div className="bg-light">
        <div className="container">
          <div className="login-card">
            {/* <div className="login-header">
              <h2>Forgot Password</h2>
            </div> */}
            <img src="/img/Webnet-Logo.png" alt="Logo" className="logo" />

            <div className="divider"><span>OR</span></div>
            <form className="login-form">
              {/* <div className="form-group">
                <label htmlFor="email">Name</label>
                <input type="text" id="username" placeholder="Enter your Username" />
              </div> */}
              <div className="form-group">
                <label htmlFor="email">UserName</label>
                <input type="text" id="username" placeholder="Enter your Username" />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input type="password" id="password" placeholder="Enter password" />
              </div>
              {/* <div className="form-options">
                <label><input type="checkbox" /> Remember Me</label>
                <a href="#">Forgot Password?</a>
              </div> */}
              <NavLink to="/dashboard"><button type="submit" className="btn submit-btn">Submit</button></NavLink>
            </form>
            <div className="signup-text">
              <p><NavLink to="/signin">Login</NavLink></p>
            </div>
          </div>
        </div>
      </div>

    </div >
  )
}

export default Signup